import { CfgStore } from '@/store/cfg';
import { util, CustomException, cache } from '@tencent/ppd-base-libs';
import { getFormatedCharityCfg } from '@/api/cfg';
import { ProjectData } from '@/types/index';


/**
 * 初始化配置
 */
export async function initCfgStore() {
  const [err, res] =  await util.to(getFormatedCharityCfg());
  if (err) {
    throw new CustomException(err, 'getHomepageInitException', 'getHomepageInitException in charity.ts');
  }
  setCfgStore(res);
}

export const isValidDate = (start?: Date, end?: Date) => {
  if (!start || !end) return true;
  const now = new Date();
  return now >= start && now <= end;
};

/** 设置数据
 * @param pageCfg
 */
export function setCfgStore(pageCfg) {
  const { bannerCfg, tabCfg, organCfg, projectCfg } = pageCfg;

  CfgStore.bannerCfg = bannerCfg.filter(banner => {
    const { startTime, endTime } = banner;
    return isValidDate(startTime, endTime);
  }).sort((a, b) => {
    const { sort: sorta = 0 } = a;
    const { sort: sortb = 0 } = b;
    return +sorta - +sortb;
  });

  CfgStore.tabCfg = tabCfg.sort((a, b) => {
    const { sort: sorta = 0 } = a;
    const { sort: sortb = 0 } = b;
    return +sorta - +sortb;
  });

  CfgStore.organCfg = organCfg;

  // 存储所有项目
  CfgStore.allProjectData = projectCfg;

  CfgStore.projectData = projectCfg.filter(project => {
    const { startTime, endTime } = project;
    return isValidDate(startTime, endTime);
  }).sort((a, b) => {
    const { sort: sorta = 0 } = a;
    const { sort: sortb = 0 } = b;
    return +sortb - +sorta;
  });


  console.log('pageData:', CfgStore);
}

/**
 * 获取项目配置，不过滤过期项目
 * @param pid
 * @returns project
 */
export function getProjectByIdInAll(pid: string) {
  return CfgStore.allProjectData.find(project => project.pid === pid);
}

/**
 * 获取项目配置，过滤过期项目
 * @param pid
 * @returns project
 */
export function getProjectById(pid: string) {
  return CfgStore.projectData.find(project => project.pid === pid);
}

/**
 * 获取不同tab下的项目列表
 */
export function filterProjectListByTabId(tabId) {
  return CfgStore.projectData.filter(project => project.tabIds.includes(tabId));
}

/**
 * 获取所属组织信息
 */
export function getOrganByOid(oid: string) {
  const organ = CfgStore.organCfg.find(organ => organ.oid === oid);
  return organ;
}

export function getOrderProjectList(projectList: ProjectData[]) {
  const pidInCache = getDonatedProjectCache();
  const upProjectList: ProjectData[] = [];
  const downProjectList: ProjectData[] = [];

  projectList.forEach((project) => {
    if (pidInCache.includes(project.pid)) {
      upProjectList.push(project);
    } else {
      downProjectList.push(project);
    }
  });

  const upProjectListSorted = getOrderProjectListInSameSort(upProjectList);
  const downProjectListSorted = getOrderProjectListInSameSort(downProjectList);

  const allArr = [...upProjectListSorted, ...downProjectListSorted];

  return allArr;
}

// 处理同权重时的排序问题
export function getOrderProjectListInSameSort(projectList: ProjectData[]) {
  const pList = projectList.sort((a, b) => {
    if (+a.sort === +b.sort) {
      const sorta = Math.floor(Math.random() * 10);
      const sortb = Math.floor(Math.random() * 10);
      return sorta - sortb;
    }
    return +b.sort - +a.sort;
  });
  return pList;
}

// 捐款完一小时内项目缓存
const CACHE_DONATE_HOUR = 'CACHE_DONATE_HOUR';

export function setDonatedProjectCache(pid: string) {
  const pCache = cache.getItemSync(CACHE_DONATE_HOUR) || {};
  const { pids = [] } = pCache;
  pids.push(pid);
  cache.setItemSync(CACHE_DONATE_HOUR, {
    pids,
  }, 60 * 60 * 1000);
}

/**
 * 返回一个小时内捐献的项目
 */
export function getDonatedProjectCache() {
  const pCache = cache.getItemSync(CACHE_DONATE_HOUR) || {};
  const { pids = [] } = pCache;
  return pids;
}

